import ValidationTooltip from '@gef-ui/material/components/ValidationTooltip';
import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';
import compose from "ramda/es/compose";
import find from "ramda/es/find";
import pluck from "ramda/es/pluck";
import prop from "ramda/es/prop";
import propEq from "ramda/es/propEq";
import defaultToEmptyObject from "ramda-extension/es/defaultToEmptyObject";
import isArray from "ramda-extension/es/isArray";
import isNilOrEmptyString from "ramda-extension/es/isNilOrEmptyString";
import React, { cloneElement } from 'react';
import { validationDisplayTypes } from '../../constants';
import { createBaseInputProps, resolveHiddenProp, resolveInputLabelProps, resolveVariant, useHelperText } from '../../utils';
const findByIndex = (index, errors)=>compose(prop('errorMessage'), defaultToEmptyObject, find(propEq(index, 'index')))(errors);
export const getOptionValues = (val)=>{
    if (isArray(val)) {
        return pluck('value', val);
    } else {
        return val?.value ?? val;
    }
};
export const getLabelFromOptions = (value, options)=>{
    if (isNilOrEmptyString(value)) {
        return null;
    } else if (isArray(value)) {
        return options.filter((option)=>value.includes(option.value));
    } else {
        return options.find((option)=>option.value === value) ?? null;
    }
};
export const renderAutocompleteTags = ({ errMeta, freeSolo, validationColor })=>(value, getTagProps)=>value.map((option, index)=>{
            const errorMessage = findByIndex(index, errMeta);
            return /*#__PURE__*/ React.createElement(Chip, {
                key: index,
                icon: /*#__PURE__*/ React.createElement(ValidationTooltip, {
                    errorMessage: errorMessage,
                    validationColor: validationColor,
                    placement: "chip-left"
                }),
                label: freeSolo ? option : option.label,
                size: "small",
                validation: validationColor,
                ...getTagProps({
                    index
                })
            });
        });
export const renderAutocompleteInput = ({ errorMessage, localizedLabel, asyncValidationInProgress, validationColor, validationDisplay, extraInputProps, label, helperText, isLoading, inputReadOnly, tooltip, variant, hidden, slotProps = {}, ...props })=>(params)=>{
        const errorOrHelperText = useHelperText(validationDisplay, errorMessage, helperText);
        const { input = {}, inputLabel = {}, formHelperText = {}, htmlInput = {} } = slotProps;
        return /*#__PURE__*/ React.createElement(TextField, {
            ...params,
            fullWidth: true,
            color: validationColor,
            helperText: errorOrHelperText,
            label: label ?? localizedLabel,
            slotProps: {
                formHelperText: {
                    validation: validationColor,
                    // workaround for https://github.com/mui/material-ui/issues/26153
                    onClick: (e)=>{
                        e.stopPropagation();
                    },
                    onMouseDown: (e)=>{
                        e.stopPropagation();
                    },
                    ...formHelperText
                },
                input: createBaseInputProps({
                    tooltipValidation: validationDisplay === validationDisplayTypes.TOOLTIP,
                    validationColor,
                    asyncValidationInProgress,
                    errorMessage,
                    tooltip,
                    InputProps: {
                        ...params.InputProps,
                        ...extraInputProps,
                        endAdornment: extraInputProps?.endAdornment && params.InputProps?.endAdornment ? /*#__PURE__*/ cloneElement(params.InputProps.endAdornment, {
                            children: /*#__PURE__*/ React.createElement(React.Fragment, null, extraInputProps.endAdornment, params.InputProps.endAdornment.props.children)
                        }) : params.InputProps?.endAdornment,
                        readOnly: inputReadOnly,
                        ...input
                    },
                    variant
                }),
                htmlInput: {
                    ...params.inputProps,
                    readOnly: inputReadOnly ?? params.inputProps.readOnly,
                    ...htmlInput
                },
                inputLabel: {
                    ...resolveInputLabelProps(variant, validationColor, props),
                    ...inputLabel
                }
            },
            "data-loader": isLoading,
            ...resolveVariant(variant),
            ...props,
            ...resolveHiddenProp(hidden, props)
        });
    };
export const resolveAutocompleteVariant = (variant)=>{
    if (variant === 'static') {
        return {
            'data-gef-variant': 'static'
        };
    }
    return {};
};
